import axios from "axios";

export const GetSintomaHomeopatiaById = async (id) => {
  const response = await axios.get(`/api/sintomaRep/${id}`);
  return response.data;
};
